import {styled} from "@mui/material/styles";
import {Switch} from "@mui/material";
import React from "react";

export const IOSSwitch = styled((props: any) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(() => ({
  width: 48,
  height: 28,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "200ms",
    "&.Mui-checked": {
      transform: "translateX(20px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#34d399", // teal-400-ish
        opacity: 1,
        border: 0
      }
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.5
    }
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 24,
    height: 24,
    boxShadow: "0 1px 2px rgba(0,0,0,0.2)"
  },
  "& .MuiSwitch-track": {
    borderRadius: 28 / 2,
    backgroundColor: "#d1d5db", // gray-300-ish
    opacity: 1,
    transition: "background-color 200ms"
  }
}));